module.exports = __webpack_public_path__ + "static/media/logov2.f53d67b6.jpg";